/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  show(inboxId) {
    return axios.get(`${this.url}/${inboxId}`);
  }
  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  // Single request: the backend resolves the eligible inboxes and applies the snapshot itself.
  applyBusinessHoursToAllInboxes(inboxId, payload) {
    return axios.post(
      `${this.url}/${inboxId}/business_hours/bulk_apply`,
      payload
    );
  }

  getPriorityQueue(inboxId) {
    return axios.get(`${this.url}/${inboxId}/priority_queue`);
  };
  
  updatePriorityQueue(inboxId, payload) {
    return axios.put(`${this.url}/${inboxId}/priority_queue`, payload);
  };
  
  shufflePriorityQueue(inboxId) {
    return axios.post(`${this.url}/${inboxId}/priority_queue_shuffle`);
  };
  
  getPriorityQueueReport(inboxId) {
    return axios.get(`${this.url}/${inboxId}/priority_queue_report`);
  };
}

export default new Inboxes();
